'use client';

import useScroll from '@/hooks/useScroll';
import clsx from 'clsx';
import { useCallback, useEffect, useState } from 'react';

import styles from './ScrollTopButton.module.css';

const ScrollTopButton = () => {
  const { y } = useScroll();
  const [snippetLoaded, setSnippetLoaded] = useState<boolean>(false)

  const handleScrollTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  useEffect(() => {
    setSnippetLoaded(!!document.getElementById('needle_pageLinc'))
  } , [y])

  return (
    <div
      id="scroll-to-top-btn"
      data-testid="scroll-to-top-btn"
      onClick={handleScrollTop}
      className={clsx(styles.scrollTopButton, {
        [styles.scrollTopButton_active]: y > 3000,
        [styles.withSnippet]: snippetLoaded
      })}
    >
      <div className={styles.scrollTopButton__btn} aria-label="backToTop">
        {y > 3000 && <div className={styles.arrowUp}></div>}
      </div>
    </div>
  );
};

export default ScrollTopButton;
